import { format } from 'date-fns'
import parse from 'date-fns/parseISO'
import PropTypes from 'prop-types'

const UserCard = props => {
  const user = props.user
  const term = props.term

  const termDates = () => {
    const startDate = parse(term.start_date)
    const endDate = parse(term.end_date)
    return `${format(new Date(startDate), 'M/dd/Y')} - ${format(
      new Date(endDate),
      'M/dd/Y',
    )}`
  }

  return (
    <div id="user-card" className="center-text">
      <h1
        id="user-card-name"
        className="text-3xl font-bold leading-7 text-center"
      >
        {user.full_name}
      </h1>
      <div id="user-card-email">
        <strong>{user.email}</strong>
      </div>
      <div id="user-card-title">
        <strong>{term.title}: </strong>
        {termDates()}
      </div>
    </div>
  )
}
UserCard.propTypes = {
  user: PropTypes.object,
  term: PropTypes.object,
}
export default UserCard
